import { useRepositorySuspenseQuery } from '@mews-commander/data-access';

export const usePrivilegeUserCanEdit = () => {
    const {
        data: { canUserEdit },
    } = useRepositorySuspenseQuery('enterprises', 'getOnboardingAuditUserPrivilege', {});

    return canUserEdit;
};
